const store = {
  metaObjects: [],
  currentMetaObjIndex: 0,
  editCurrentMetaObj: false,
  schemas: {},
  errors: [], // to be removed later after full refactor
  warnings: [], // to be removed later after full refactor
  csvFiles: [],
  csvFileErrors: [],
};

export default store;
